import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface LocationPinIconProps extends SvgIconProps {}

export const LocationPinIcon = ({
  style,
  ...iconProps
}: LocationPinIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon style={style} {...iconProps} viewBox="0 0 16.1 23">
      <path
        d="M15.55,3A8.044,8.044,0,0,0,7.5,11.05C7.5,17.087,15.55,26,15.55,26s8.05-8.913,8.05-14.95A8.044,8.044,0,0,0,15.55,3Zm0,10.925a2.875,2.875,0,1,1,2.875-2.875A2.876,2.876,0,0,1,15.55,13.925Z"
        transform="translate(-7.5 -3)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
